export const REDUCER_NAME="attributeSlice";

export interface iAttributeRespone {
    id: string;
    name:string;
    created_at: string;
    updated_at: string; 

  }

  
  export interface iAttributeState {
      attributeDetail: iAttributeRespone | null;
      attributeList:[]
      isLoading: boolean;
      errorMessage: string | null;
  }

  export interface iAttributeDTO{
    name?:string
  }